var _rect, _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 735,
    height: 225,
    viewBox: "0 0 735 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 498.463,
    width: 236.536,
    height: 67.6339,
    rx: 33.817,
    fill: "url(#paint0_linear_2553_1068)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 701.256,
    cy: 33.817,
    rx: 33.7432,
    ry: 33.817,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 225V95.759H50.3578C87.6264 95.759 101.92 109.485 101.92 128.865C101.92 139.983 97.6761 152.089 86.2025 155.521C98.2785 159.556 105.946 173.09 105.946 185.607C105.946 206.608 93.0483 224.973 51.371 224.973H0V225ZM32.6408 147.038H50.5769C66.8973 147.038 69.9094 141.383 69.9094 134.328C69.9094 127.273 67.6914 122.003 50.9876 122.003H32.6682V147.038H32.6408ZM32.6408 198.729H51.9734C69.4987 198.729 72.7299 192.058 72.7299 184.4C72.7299 176.329 70.1011 170.454 52.5758 170.454H32.6408V198.729Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.355 225L153.894 95.759H194.996L240.507 225H206.251L199.213 202.792H149.649L142.612 225H108.383H108.355ZM156.687 178.745H192.148L174.212 124.226L156.687 178.745Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M252.583 225V95.759H292.672L340.401 178.141V95.759H373.234V225H334.76L285.607 143.03V225H252.583Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M399.192 225V95.759H431.833V146.434L469.102 95.759H512.395L459.025 157.552L515.215 225H472.114L431.833 169.686V225H399.192Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M520.255 225V95.759H552.896V225H520.255Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M578.444 225V95.759H670.507V122.414H610.893V151.485H666.098V176.713H610.893V224.973H578.472L578.444 225Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M686.991 225V95.759H719.632V225H686.991Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2553_1068",
    x1: 498.463,
    y1: 33.817,
    x2: 734.999,
    y2: 33.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3F982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462297,
    stopColor: "#00B189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F7DFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppLogo);
export default __webpack_public_path__ + "static/media/appLogo.8c8d727ab4875ded3efac003def2105a.svg";
export { ForwardRef as ReactComponent };